import { Outlet } from 'react-router-dom';
import { ToastContainer, Bounce } from 'react-toastify';

import { ThemeProvider } from '../contexts/ThemeContext';
import { NavigationProvider } from '../contexts/NavigationContext';
import { useOnboardingRedirect } from '../hooks/useOnboardingRedirect';
import EnvironmentBanner from '../components/EnvironmentBanner';
import PwaInstallPromotion from '../components/pwa/PwaInstallPromotion';

function RootLayout() {
  useOnboardingRedirect();

  return (
    <ThemeProvider>
      <NavigationProvider>
        <EnvironmentBanner />
        <Outlet />

        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <PwaInstallPromotion />
      </NavigationProvider>
    </ThemeProvider>
  );
}

export default RootLayout;